import Axios from "axios"
import { schedule_load } from "../data"


export function schedule_add(props) {
    const scheduleList = props['scheduleList']
    const Set_scheduleList = props['Set_scheduleList']

    scheduleList.push({
        'set': 'save',
        'title': '',
        'description': '',
        'time': '',
        'number': 0,
        'grade': [],
        'public': true,
        'start': '',
        'end': '',
        'payment': 0,
        'onlyEnrolled': false
    })
    Set_scheduleList([...scheduleList])
}


export async function schedule_remove(props) {
    const set = props['set']
    const index = props['index']
    const scheduleList = props['scheduleList']
    const Set_scheduleList = props['Set_scheduleList']

    if(set === 'save') {
        const new_scheduleList = []
        for(let i=0; i<scheduleList.length; i++) {
            if(index !== i) {
                new_scheduleList.push(scheduleList[i])
            }
        }

        await Set_scheduleList(new_scheduleList)
    }
    else if(
        set === 'edit' &&
        window.confirm('삭제하시겠습니까?')
    ) {

        const event_id = props['event_id']
        const schedule_id = props['schedule_id']

        Axios
        .post('/schedule/remove', {
            event_id: event_id,
            schedule_id: schedule_id
        })
        .then(res => {
            alert(res.data.message)
            if(res.data.status === 'success') {
                schedule_load()
            }
        })
    }
}


export function grade_setup(props) {
    const gradeList = window.EventManager['gradeList']

    const set = props['set']
    const scheduleList = props['scheduleList']
    const Set_scheduleList = props['Set_scheduleList']
    const index = props['index']
    const index2 = props['index2']
    const value = props['value']
    const checked = props['checked']
    const grade = scheduleList[index]['grade']

    if(set === 'all') {
        const new_grade = []
        if(checked) {
            for(let i=0; i<gradeList.length; i++) {
                new_grade.push(gradeList[i]['Mcode'].trim())
            }
        }
        scheduleList[index]['grade'] = new_grade
        Set_scheduleList((preState) => {
            return [...preState]
        })
    }
    else {
        const findIndex = grade.findIndex(x => x === value)
        if(checked && findIndex === -1) {
            grade.push(value)
        }
        else {
            const new_grade = []
            for(let i=0; i<grade.length; i++) {
                if(findIndex !== i) {
                    new_grade.push(grade[i])
                }
            }
            scheduleList[index]['grade'] = new_grade
        }

        const register = document.getElementById('register')
        if(gradeList.length === scheduleList[index]['grade'].length) {
            register.querySelector(`[set="grade_all"][index="${index}"]`).checked = true
        }
        else {
            register.querySelector(`[set="grade_all"][index="${index}"]`).checked = false
        }
    }
}


export function form_save(props) {
    const branchInfo = window.EventManager.branchInfo
    const selectEevent = window.EventManager.selectEevent
    const selectDay = window.EventManager.selectDay

    const scheduleList = props['scheduleList']
    const Set_scheduleList = props['Set_scheduleList']

    if(selectDay.length === 0) {
        alert('날짜를 선택해 주세요.')
    }
    else if(scheduleList.length === 0) {
        alert('일정을 추가해 주세요.')
    }
    else if(window.confirm('등록하시겠습니까?')) {
        const data = []
        for(let i=0; i<selectDay.length; i++) {
            const day = selectDay[i]['value']

            for(let j=0; j<scheduleList.length; j++) {
                const set = scheduleList[j]['set']
                const title = scheduleList[j]['title']
                const description = scheduleList[j]['description']
                const time = scheduleList[j]['time']
                const number = scheduleList[j]['number']
                const grade = scheduleList[j]['grade']
                const public_ = scheduleList[j]['public']
                const start = scheduleList[j]['start']
                const end = scheduleList[j]['end']
                const payment = scheduleList[j]['payment']
                const onlyEnrolled = scheduleList[j]['onlyEnrolled']

                const schedule_id = scheduleList[j]['schedule_id']

                if(
                    time === '' ||
                    number === '' ||
                    grade.length === 0
                ) {
                    return alert('필수 항목을 입력해 주세요.')
                }

                if(
                    time !== '' &&
                    number !== '' &&
                    grade.length !== 0
                ) {
                    data.push({
                        'set': set,
                        'title': title,
                        'description': description,
                        'day': day,
                        'time': time,
                        'number': number,
                        'grade': grade,
                        'public': public_,
                        'start': start,
                        'end': end,
                        'payment': payment,
                        'schedule_id': schedule_id,
                        'onlyEnrolled': onlyEnrolled
                    })
                }
            }
        }

        if(data.length === 0) {
            alert('필수 항목을 입력해 주세요.')
        }
        else {
            const branch_id = branchInfo['id']
            const branch_name = branchInfo['name']
            const event_id = selectEevent['id']

            Axios
            .post('/schedule/save', {
                branch_id: branch_id,
                branch_name: branch_name,
                event_id: event_id,
                data: data
            })
            .then(res => {
                alert(res.data.message)
                if(res.data.status === 'success') {
                    Set_scheduleList([])
                    schedule_load()
                }
            })
        }
    }
}